// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
    /* background-color: #fcfaf7; */
    /* backdrop-filter: blur(8px); */
    height: 64px;
    /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06); */
    display: flex;
    align-items: center;
    font-size: 1.2rem;
    position: sticky;
    top: 0;
    z-index: 999;
    width: 100%;
    /* border-bottom: 1px solid rgba(0, 0, 0, 0.06); */
}

.navbar-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    width: 100%;
    max-width: 100%;
    padding: 0 24px;
}

.navbar-logo {
    color: #1a1a1a;
    text-decoration: none;
    font-size: 1.75rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    font-family: "Gabarito", serif;
    transition: all 0.2s ease;
    margin-right: auto;
}


.navbar-logo img {
    display: block !important;
}

.nav-menu {
    display: flex;
    gap: 12px;
    margin-left: auto;
    align-items: center;
}

.hamburger-menu {
    display: none;
    flex-direction: column;
    justify-content: space-between;
    width: 24px;
    height: 20px;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    transition: all 0.3s ease;
}

.hamburger-line {
    width: 100%;
    height: 2px;
    background-color: #374151;
    transition: all 0.3s ease;
    border-radius: 2px;
}

/* Enhanced Mobile Styles */
@media (max-width: 992px) {
    .navbar-container {
        padding: 0 16px;
        flex-direction: row-reverse;
    }

    .navbar-logo {
        margin-right: initial;
    }

    .hamburger-menu {
        display: flex;
    }

    .hamburger-menu:hover {
        background-color: rgba(0, 0, 0, 0.05);
    }

    .nav-menu {
        position: absolute;
        top: 64px;
        left: 0;
        flex-direction: column;
        width: 100%;
        background-color: rgba(255, 255, 255, 0.98);
        backdrop-filter: blur(8px);
        transform: translateY(-100%);
        opacity: 0;
        visibility: hidden;
        /* transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); */
        padding: 16px;
        gap: 12px;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        justify-content: flex-start;
        box-sizing: border-box;
    }

    .nav-menu.open {
        transform: translateY(0);
        opacity: 1;
        visibility: visible;
        z-index: -1;
        padding: 24px 16px;
    }

    .nav-menu.open::before {
        content: '';
        position: absolute;
        top: auto;
        left: 0;
        right: 0;
        background: rgba(255, 255, 255, 0.98);
        bottom: 100%;
        height: 100%;
        width: 100%;
        z-index: -1;
    }

    .nav-menu>div {
        flex-direction: column; 
    }

    .nav-menu .item {
        display: flex;
        justify-content: center;
    }

    /* Animated hamburger menu */
    .hamburger-menu.open .hamburger-line:nth-child(1) {
        transform: translateY(9px) rotate(45deg);
    }

    .hamburger-menu.open .hamburger-line:nth-child(2) {
        opacity: 0;
    }

    .hamburger-menu.open .hamburger-line:nth-child(3) {
        transform: translateY(-9px) rotate(-45deg);
    }
}

/* Add smooth transition for navbar shadow on scroll */
.navbar.scrolled {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    background-color: rgba(255, 255, 255, 0.95);
}

.navbar .btn.theme-button {
    display: flex;
    align-items: center;
    gap: 10px;
    font-family: 'Crimson', serif;
    font-weight: 700;
    text-transform: uppercase;
    border: none;
    border-radius: 50px;
    background-image: none;
    background-color: transparent;
}

.navbar .btn.theme-button .drip {
    display: none;
}

.navbar .btn.theme-button:hover {
    background-color: transparent;
}

.navbar .btn.theme-button:focus {
    background-color: transparent;
}

.navbar .btn.theme-button:hover span {
    color: #000;
}

.navbar .btn.theme-button > .icon {
    left: auto;
    position: relative;
    top: 9px;
}

.navbar .btn.theme-button > .text {
    padding: 0;
}

.navbar .btn.theme-button > .icon svg {
    width: 22px;
    height: 22px; 
}

.navbar .btn.theme-button span {
    color: #454545;
    font-size: 16px;
    letter-spacing: 1px;
    line-height: 1;
}

.logo-container {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.chester-icon {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

/* User profile styles */
.user-profile-nav {
  margin-left: 16px;
}

.user-avatar-container {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 50%;
  transition: background-color 0.2s;
}

.user-avatar-container:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.user-popover {
  padding: 12px;
  min-width: 220px;
}

.user-popover-header {
  margin-bottom: 16px;
}

.user-popover-header h4 {
  margin: 0 0 4px 0;
  font-size: 16px;
}

.user-popover-header p {
  margin: 0;
  font-size: 14px;
}

.patron-badge {
  display: inline-block;
  background-color: #F96854;
  color: white;
  border-radius: 4px;
  padding: 2px 6px;
  margin-top: 8px;
  font-size: 0.75rem;
}

.patron-text {
  color: white !important;
  font-weight: 600;
}

.user-popover-actions {
  display: flex;
  justify-content: flex-end;
}

.navbar-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  height: 100%;
}

.navbar-divider-line {
  height: 32px;
  width: 1.5px;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 0.5px;
}

@media (max-width: 992px) {
  .user-profile-nav {
    margin-left: auto;
    margin-right: 16px;
  }

  .navbar-divider {
    display: none;
  }
  
  /* Add bottom border to create visual separation in mobile menu */
  .nav-menu.open .navbar-divider + div {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    margin-top: 8px;
    padding-top: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/navbar/Navbar.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,gCAAgC;IAChC,YAAY;IACZ,+CAA+C;IAC/C,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,MAAM;IACN,YAAY;IACZ,WAAW;IACX,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;IACzB,kBAAkB;AACtB;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA,2BAA2B;AAC3B;IACI;QACI,eAAe;QACf,2BAA2B;IAC/B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,OAAO;QACP,sBAAsB;QACtB,WAAW;QACX,2CAA2C;QAC3C,0BAA0B;QAC1B,4BAA4B;QAC5B,UAAU;QACV,kBAAkB;QAClB,uDAAuD;QACvD,aAAa;QACb,SAAS;QACT,wCAAwC;QACxC,2BAA2B;QAC3B,sBAAsB;IAC1B;;IAEA;QACI,wBAAwB;QACxB,UAAU;QACV,mBAAmB;QACnB,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,SAAS;QACT,OAAO;QACP,QAAQ;QACR,qCAAqC;QACrC,YAAY;QACZ,YAAY;QACZ,WAAW;QACX,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,uBAAuB;IAC3B;;IAEA,4BAA4B;IAC5B;QACI,wCAAwC;IAC5C;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,0CAA0C;IAC9C;AACJ;;AAEA,sDAAsD;AACtD;IACI,0CAA0C;IAC1C,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,6BAA6B;IAC7B,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA,iEAAiE;EACjE;IACE,wCAAwC;IACxC,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".navbar {\n    /* background-color: #fcfaf7; */\n    /* backdrop-filter: blur(8px); */\n    height: 64px;\n    /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06); */\n    display: flex;\n    align-items: center;\n    font-size: 1.2rem;\n    position: sticky;\n    top: 0;\n    z-index: 999;\n    width: 100%;\n    /* border-bottom: 1px solid rgba(0, 0, 0, 0.06); */\n}\n\n.navbar-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 100%;\n    width: 100%;\n    max-width: 100%;\n    padding: 0 24px;\n}\n\n.navbar-logo {\n    color: #1a1a1a;\n    text-decoration: none;\n    font-size: 1.75rem;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    font-family: \"Gabarito\", serif;\n    transition: all 0.2s ease;\n    margin-right: auto;\n}\n\n\n.navbar-logo img {\n    display: block !important;\n}\n\n.nav-menu {\n    display: flex;\n    gap: 12px;\n    margin-left: auto;\n    align-items: center;\n}\n\n.hamburger-menu {\n    display: none;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 24px;\n    height: 20px;\n    cursor: pointer;\n    padding: 4px;\n    border-radius: 4px;\n    transition: all 0.3s ease;\n}\n\n.hamburger-line {\n    width: 100%;\n    height: 2px;\n    background-color: #374151;\n    transition: all 0.3s ease;\n    border-radius: 2px;\n}\n\n/* Enhanced Mobile Styles */\n@media (max-width: 992px) {\n    .navbar-container {\n        padding: 0 16px;\n        flex-direction: row-reverse;\n    }\n\n    .navbar-logo {\n        margin-right: initial;\n    }\n\n    .hamburger-menu {\n        display: flex;\n    }\n\n    .hamburger-menu:hover {\n        background-color: rgba(0, 0, 0, 0.05);\n    }\n\n    .nav-menu {\n        position: absolute;\n        top: 64px;\n        left: 0;\n        flex-direction: column;\n        width: 100%;\n        background-color: rgba(255, 255, 255, 0.98);\n        backdrop-filter: blur(8px);\n        transform: translateY(-100%);\n        opacity: 0;\n        visibility: hidden;\n        /* transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); */\n        padding: 16px;\n        gap: 12px;\n        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n        justify-content: flex-start;\n        box-sizing: border-box;\n    }\n\n    .nav-menu.open {\n        transform: translateY(0);\n        opacity: 1;\n        visibility: visible;\n        z-index: -1;\n        padding: 24px 16px;\n    }\n\n    .nav-menu.open::before {\n        content: '';\n        position: absolute;\n        top: auto;\n        left: 0;\n        right: 0;\n        background: rgba(255, 255, 255, 0.98);\n        bottom: 100%;\n        height: 100%;\n        width: 100%;\n        z-index: -1;\n    }\n\n    .nav-menu>div {\n        flex-direction: column; \n    }\n\n    .nav-menu .item {\n        display: flex;\n        justify-content: center;\n    }\n\n    /* Animated hamburger menu */\n    .hamburger-menu.open .hamburger-line:nth-child(1) {\n        transform: translateY(9px) rotate(45deg);\n    }\n\n    .hamburger-menu.open .hamburger-line:nth-child(2) {\n        opacity: 0;\n    }\n\n    .hamburger-menu.open .hamburger-line:nth-child(3) {\n        transform: translateY(-9px) rotate(-45deg);\n    }\n}\n\n/* Add smooth transition for navbar shadow on scroll */\n.navbar.scrolled {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n    background-color: rgba(255, 255, 255, 0.95);\n}\n\n.navbar .btn.theme-button {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-family: 'Crimson', serif;\n    font-weight: 700;\n    text-transform: uppercase;\n    border: none;\n    border-radius: 50px;\n    background-image: none;\n    background-color: transparent;\n}\n\n.navbar .btn.theme-button .drip {\n    display: none;\n}\n\n.navbar .btn.theme-button:hover {\n    background-color: transparent;\n}\n\n.navbar .btn.theme-button:focus {\n    background-color: transparent;\n}\n\n.navbar .btn.theme-button:hover span {\n    color: #000;\n}\n\n.navbar .btn.theme-button > .icon {\n    left: auto;\n    position: relative;\n    top: 9px;\n}\n\n.navbar .btn.theme-button > .text {\n    padding: 0;\n}\n\n.navbar .btn.theme-button > .icon svg {\n    width: 22px;\n    height: 22px; \n}\n\n.navbar .btn.theme-button span {\n    color: #454545;\n    font-size: 16px;\n    letter-spacing: 1px;\n    line-height: 1;\n}\n\n.logo-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.chester-icon {\n  width: 32px;\n  height: 32px;\n  object-fit: contain;\n}\n\n/* User profile styles */\n.user-profile-nav {\n  margin-left: 16px;\n}\n\n.user-avatar-container {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  border-radius: 50%;\n  transition: background-color 0.2s;\n}\n\n.user-avatar-container:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.user-popover {\n  padding: 12px;\n  min-width: 220px;\n}\n\n.user-popover-header {\n  margin-bottom: 16px;\n}\n\n.user-popover-header h4 {\n  margin: 0 0 4px 0;\n  font-size: 16px;\n}\n\n.user-popover-header p {\n  margin: 0;\n  font-size: 14px;\n}\n\n.patron-badge {\n  display: inline-block;\n  background-color: #F96854;\n  color: white;\n  border-radius: 4px;\n  padding: 2px 6px;\n  margin-top: 8px;\n  font-size: 0.75rem;\n}\n\n.patron-text {\n  color: white !important;\n  font-weight: 600;\n}\n\n.user-popover-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.navbar-divider {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 4px;\n  height: 100%;\n}\n\n.navbar-divider-line {\n  height: 32px;\n  width: 1.5px;\n  background-color: rgba(0, 0, 0, 0.2);\n  border-radius: 0.5px;\n}\n\n@media (max-width: 992px) {\n  .user-profile-nav {\n    margin-left: auto;\n    margin-right: 16px;\n  }\n\n  .navbar-divider {\n    display: none;\n  }\n  \n  /* Add bottom border to create visual separation in mobile menu */\n  .nav-menu.open .navbar-divider + div {\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\n    margin-top: 8px;\n    padding-top: 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
